import { render, staticRenderFns } from "./AttachmentFile.vue?vue&type=template&id=5e79bd10&"
import script from "./AttachmentFile.vue?vue&type=script&lang=js&"
export * from "./AttachmentFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports